import { AxiosResponse } from 'axios';
import SecureClient from '../SecureClient';
import { BaseTandemAccountModel, TandemAccount } from './DTOs';

export default class TandemAccountsClient extends SecureClient {

	public getAccounts = (): Promise<AxiosResponse<TandemAccount[]>> => {
		return this._api.get<TandemAccount[]>('TandemAccounts', {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public getAccount = (accountId: number): Promise<AxiosResponse<TandemAccount>> => {
		return this._api.get<TandemAccount>(`TandemAccounts/${accountId}`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public createAccount = (account: BaseTandemAccountModel): Promise<AxiosResponse<TandemAccount>> => {
		return this._api.post<TandemAccount>("TandemAccounts", account, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public updateAccount = (accountId: number, accountModel: BaseTandemAccountModel): Promise<AxiosResponse<TandemAccount>> => {
		return this._api.put<TandemAccount>(`TandemAccounts/${accountId}`, accountModel, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public deleteAccount = (accountId: number): Promise<AxiosResponse> => {
		return this._api.delete(`TandemAccounts/${accountId}`, {
			headers: {
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

}